import { OkResponseDto } from "@/data/dto/ok-response-dto";
import { AuthSource } from "@/data/source/auth-source";
import { AuthRepository } from "@/domain/repository/auth-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class AuthRepositoryImpl implements AuthRepository {
  constructor(private readonly authSource: AuthSource) {}

  async exchangeAndSaveAESecretKeyByCookie(): Promise<SATResult<void, SATError>> {
    const result = await this.authSource.exchangeSecretKeyByCookie();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async reissueWebUserToken(): Promise<SATResult<OkResponseDto, SATError>> {
    const result = await this.authSource.reissueWebUserToken();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(result.value);
  }

  async clearAuthStorage(): Promise<SATResult<void, SATError>> {
    const result = await this.authSource.clearAuthStorage();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }
}
